/*eslint react-hooks/exhaustive-deps: "off"*/
import WidgetSelect from "./WidgetSelect";
import React, { useCallback, useContext } from "react";
import SpectrumContext from "./SpectrumContext";
import "./SpectrumForm.scss";

const FormSearch = () => {
  const {
    inputsState,
    onChangeInputsState,
    sidoList,
    ucodeList,
    usageList,
  } = useContext(SpectrumContext);

  const onChange = useCallback(
    (checkedValues, fieldName) => {
      const oldValues = inputsState[fieldName];
      if (JSON.stringify(oldValues) !== JSON.stringify(checkedValues)) {
        onChangeInputsState({
          target: { name: fieldName, value: checkedValues },
        });
      }
    },
    [inputsState]
  );

  return (
    <div className="SpectrumForm">
      <div className="field">
        <label className="ant-form-item-label">지역</label>
        <WidgetSelect
          data={sidoList}
          value={inputsState.sidoCheckList}
          onChangeValues={(values) => onChange(values, "sidoCheckList")}
          disabled={sidoList.length === 0}
          inputStyle={{ width: 200 }}
        />
      </div>

      <div className="field">
        <label className="ant-form-item-label">구분</label>
        <WidgetSelect
          data={ucodeList}
          value={inputsState.ucodeCheckList}
          onChangeValues={(values) => onChange(values, "ucodeCheckList")}
          disabled={
            inputsState.sidoCheckList.length === 0 || ucodeList.length === 0
          }
          inputStyle={{ width: 200 }}
        />
      </div>

      <div className="field2">
        <label className="ant-form-item-label">용도</label>
        <WidgetSelect
          data={usageList}
          value={inputsState.usageCheckList}
          onChangeValues={(values) => onChange(values, "usageCheckList")}
          disabled={
            inputsState.sidoCheckList.length === 0 ||
            inputsState.ucodeCheckList.length === 0 ||
            usageList.length === 0
          }
          inputStyle={{ width: 320 }}
        />
      </div>
    </div>
  );
};

export default FormSearch;
